// Generated by Melange

import * as Buhta_conf__Config from "../../../../../packages/conf/lib/Config.js";
import * as Buhta_router__CabinetRoute from "../../../../../packages/router/lib/CabinetRoute.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function LinkToCabinet(Props) {
  let route = Props.route;
  let className = Props.className;
  let tabIndex = Props.tabIndex;
  let onLinkClickedOpt = Props.onLinkClicked;
  let children = Props.children;
  const onLinkClicked = onLinkClickedOpt !== undefined ? onLinkClickedOpt : (function (param) {
      
    });
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const cabinetUrl = cfg.cabinet_url + Buhta_router__CabinetRoute.toString(route);
  let tmp = {
    children: children,
    href: cabinetUrl,
    onClick: (function (param) {
      Curry._1(onLinkClicked, undefined);
    })
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (tabIndex !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  return JsxRuntime.jsx("a", tmp);
}

const make = LinkToCabinet;

export {
  make,
}
/* Buhta_conf__Config Not a pure module */
